import { UserState } from 'src/reducers/userReducer/types';
import store from 'src/store/store';

export function getUserOrgCode() {
  return (store.getState().user as UserState).orgCode || undefined;
}
